module.exports = __webpack_public_path__ + "static/media/020.ea5b9a95.jpg";